<!-- 变配电 -->

<template>
  <div class="ele-container">
    <div
      class="pdjA"
      @click="toPDJA"
      :class="{ 'pdjA-show': pdjName == 'PDJ_A' }"
    ></div>
    <div
      class="pdjB"
      @click="toPDJB"
      :class="{ 'pdjB-show': pdjName == 'PDJ_D' }"
    ></div>
    <div class="left-content" v-if="isShowDialog">
      <pannel-box :headerName="'变配电设备'" :headerData="equInfo">
        <div class="detail">
          <div
            class="contentList"
            v-for="(item, key, index) in botData"
            :key="index"
          >
            <div class="text" @click="chooseData(key)">{{ key }}</div>
            <div
              class="value"
              :class="item.alarm == '0' ? 'normalData-color' : 'alarm-color '"
            >
              {{ showItem(item.value)
              }}<span class="detail-unit-data">{{ showUnit(item.value) }}</span>
            </div>
          </div>
        </div>
        <div class="time-type-select">
          <div
            class="time-type-item"
            :id="timeValue == 'day' ? 'active' : ''"
            @click="changeDay('day')"
          >
            时
          </div>
          <div
            class="time-type-item"
            :id="timeValue == 'month' ? 'active' : ''"
            @click="changeDay('month')"
          >
            日
          </div>
          <div
            class="time-type-item"
            :id="timeValue == 'year' ? 'active' : ''"
            @click="changeDay('year')"
          >
            月
          </div>
        </div>
        <div class="bot-content">
          <custom-charts
            :title="dataBtn"
            :dataList="dataList"
            :timer="timeValue"
          ></custom-charts>
        </div>
      </pannel-box>
    </div>
    <div class="ele-transform common-bg">
      <total-power :powerData="powerData" :pdjName="pdjName"></total-power>
      <custom-num :cusNumData="powerData" :pdjName="pdjName"></custom-num>
      <table-list
        ref="eleTransform"
        :header="header"
        :tableData="tableData"
        :isLoadEnd="isLoadEnd"
        @nowClickData="nowClickData"
      ></table-list>
      <!-- <tem-switch></tem-switch> -->
    </div>
  </div>
</template>
<script>
import CustomNum from "./components/custom-num.vue";
import TemSwitch from "./components/tem-switch.vue";
import totalPower from "./components/total-power.vue";
import bus from "@/components/three-scene/Bus.js";
import { getEqpInfo, getPowerSupplyData, getEqpByName } from "@/api/index.js";
import PowerData from "./components/power-data.vue";
import TableList from "./components/table-list.vue";

export default {
  components: { totalPower, CustomNum, TemSwitch, PowerData, TableList },
  mounted() {
    this.$store.state.threeEvent.intoPDJ = true;
    bus.on("pdjd1", this.showDialog);
    bus.on("pdja1", this.showDialog);
    bus.on("closepdja1", () => {
      this.isShowDialog = false;
      this.currentEqpCode = "";
    });
    bus.on("closBack", (data) => {
      this.isShowDialog = data;
      this.$refs.eleTransform.selectIndex = null;
    });

    // bus.emit("PDJ");
    // bus.on("boxNum", this.setTableState);
  },
  created() {
    bus.emit("changeScene", "PDJ_A");
    bus.on("qieHuan", (data) => {
      if (data == "PDJ_D") {
        this.toPDJB();
      } else {
        this.toPDJA();
      }
    });
    this.getEleData();
    this.ReqEqpByName();
    this.getChartData();
    this.timer = setInterval(() => {
      this.getEleData();
      this.ReqEqpByName();
      // this.loadData(10, 13);
    }, 30*60*1000);
  },
  watch: {
    historical() {
      this.getChartData();
    },
    equInfo() {
      this.dataBtn = "用电量";
    },
    dataBtn() {
      this.getChartData();
    },
  },
  data() {
    return {
      timeValue: "day",
      map: {
        day: "当日",
        month: "当月",
        year: "当年",
      },
      dataList: {
        x: [],
        y: [],
      },
      isShowDialog: false,
      equInfo: {},
      monitorList: {},
      distribution: {},
      botData: {},
      currentEqpCode: "",
      calendar: "",
      pdjName: "PDJ_A",
      pdjName2: null,
      listData: {},
      powerData: {},
      powerDialogData: {},
      header: [
        {
          name: "设备位置",
          key: "buildNo",
        },
        {
          name: "机柜编号",
          key: "floor",
        },
        {
          name: "设备名",
          key: "eqpName",
        },
      ],
      tableData: [],
      isLoadEnd: false,
      historical: {},
      dataBtn: "用电量",
      timer: null,
    };
  },
  methods: {
    showItem(val) {
      if (val.includes(".")) {
        return val.split(".")[0] + "." + val.split(".")[1].slice(0, 2);
      } else if (val == "暂无数据") {
        return "-";
      } else {
        return val;
      }
    },
    chooseData(i) {
      this.dataBtn = i;
    },
    loadData(first, end) {
      this.dataList = { x: [], y: [] };
      this.historical?.[this.timeValue]?.[this.dataBtn].map((item, index) => {
        let [res] = Object.entries(item);
        console.log(res[0]);
        this.dataList.x.push(res[0].slice(first, end));
        this.dataList.y.push(res[1]);
      });
    },

    changeDay(value) {
      this.timeValue = value;
      this.getChartData();
    },
    getChartData() {
      if (this.timeValue == "day") {
        this.loadData(10, 13);
      } else if (this.timeValue == "month") {
        this.loadData(8, 11);
      } else {
        this.loadData(5, 8);
      }
    },
    showUnit(val) {
      if (val.includes(".")) {
        return val.split(".")[1].slice(2);
      }
    },
    async showDialog(a) {
      if (this.currentEqpCode == a) return;
      this.currentEqpCode = a;
      let { data: res } = await getEqpInfo({
        eqpCode: a,
      });
      this.equInfo = res.baseData;
      // 变配电弹框图表
      this.powerDialogData = res;
      this.botData = res.collectionValue.data;
      this.historical = res.historical;
      this.powerDialogData.totalPower = this.powerData?.totalPower;
      this.isShowDialog = true;
    },
    toPDJA() {
      if (this.isShowDialog) {
        this.isShowDialog = false;
      }
      this.pdjName = "PDJ_A";
      bus.emit("changeScene", this.pdjName);
      bus.emit("buttonCut");
      bus.emit("tableData", this.pdjName);
    },
    toPDJB() {
      if (this.isShowDialog) {
        this.isShowDialog = false;
      }
      this.pdjName = "PDJ_D";
      bus.emit("changeScene", this.pdjName);
      bus.emit("buttonCut");
      bus.emit("tableData", this.pdjName);
    },
    async getEleData() {
      let { data: res } = await getPowerSupplyData();
      this.powerData = res;
    },
    async ReqEqpByName() {
      let { data: res } = await getEqpByName();
      this.isLoadEnd = true;
      this.tableData = res;
    },
    // 当前点击的变电所
    nowClickData(data) {
      if (data.number.slice(0, 1).includes("B")) {
        this.pdjName = "PDJ_D";
        bus.emit("changeScene", this.pdjName, false);
      } else {
        this.pdjName = "PDJ_A";
        bus.emit("changeScene", this.pdjName, false);
      }
    },
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
    bus.emit("noFixed");
  },
};
</script>

<style lang="scss" scoped>
.ele-container {
  position: relative;
}

.left-content {
  position: absolute;
  right: 43px;
  top: 135px;
  width: 381px;

  .plane-left {
    width: 100%;
    height: 100%;
    padding: 20px;
    padding-left: 34px;

    .line-item {
      width: 100%;
      height: 30px;
      display: flex;
      justify-content: space-between;
      color: #ffffff;
      font-weight: 500;
      font-size: 18px;
      line-height: 29px;

      &:not(:first-child) {
        margin-top: 20px;
      }
    }
  }
}
.detail {
  display: grid;
  grid-template-columns: 160px 160px;
  // grid-template-rows: repeat(5, 29px);
  gap: 4px 20px;
  overflow: hidden;
  .contentList {
    padding: 3.5px 4px;
    display: flex;
    justify-content: space-between;
    width: 165px;
    font-size: 14px;
    color: rgba(239, 239, 239, 0.7);
    background: linear-gradient(
      270deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.2) 100%
    );
    .value {
      width: 91px;
      text-align: right;
    }
    .normalData-color {
      color: #fff;
    }
    .alarm-color {
      color: #f1802f;
    }
    .text {
      // color: #fff;
      width: 62px;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      // white-space: pre-wrap;
    }
  }
}
.time-type-select {
  margin-top: 20px;
  display: flex;
  align-items: center;
  .time-type-item {
    margin-right: 7px;
    width: 40px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    cursor: pointer;
  }

  .time-type-item:last-child {
    margin-right: 0;
  }
  #active {
    background: rgba(175, 175, 175, 0.2);
  }
}
.bot-content {
  margin-top: 15px;
  width: 341px;
  height: 140px;
}
.pdjA {
  position: absolute;
  left: 541px;
  top: 135px;
  width: 112px;
  height: 44px;
  cursor: pointer;
  background: url("../../../../../../assets/cut/defaultA.png");
  background-size: cover;
}
.pdjA-show {
  background: url("../../../../../../assets/cut/selectA.png");
  background-size: cover;
}
.pdjB {
  position: absolute;
  left: 671px;
  top: 135px;
  width: 112px;
  height: 44px;
  cursor: pointer;
  background: url("../../../../../../assets/cut/defaultB.png");
  background-size: cover;
}
.pdjB-show {
  background: url("../../../../../../assets/cut/selectB.png");
  background-size: cover;
}
.ele-transform {
  position: absolute;
  width: 416px;
  top: 135px;
  left: 107px;
  pointer-events: all;
}
</style>
<style lang="scss">
.PDJNormal {
  background: rgba(51, 59, 98, 0.8);

  .pdj-splitline {
    background-color: #2d82ff;
  }
}

.PDJStandy {
  background: rgba(75, 77, 87, 0.8);

  .pdj-splitline {
    background-color: #afafaf;
  }
}

.PDJError {
  background: rgba(134, 98, 71, 0.9);

  .pdj-splitline {
    background-color: #f1802f;
  }

  .scrip-class {
    background: rgba(0, 0, 0, 0.2) !important;
  }
}

.PDJInfo {
  position: absolute;
  top: 135px;
  right: 500px;
  width: 374px;
  height: 476px;
  backdrop-filter: blur(5px);

  .info-list {
    padding: 20px;
    padding-top: 15px;
    color: #ffffff;

    .dataitem-marin {
      margin-top: 10px;
    }

    .info-dataitem {
      display: flex;
    }

    .ele-leftname,
    .ele-rightdata {
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
    }

    .ele-rightdata {
      margin-left: 25px;
    }
  }

  .pdj-splitline {
    width: 334px;
    height: 1px;
    margin-left: 20px;
  }

  .detial-info-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    color: #ffffff;
    margin-top: 14px;
    margin-left: 24px;
  }

  .detial-info-list {
    width: 100%;
    margin-top: 11px;

    .scrip-class {
      background: rgba(0, 0, 0, 0.3);
    }

    .detial-info-item {
      height: 26px;
      padding-left: 27px;
      display: flex;
      align-items: center;
      color: #ffffff;

      .info-item-left,
      .info-item-right {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
      }

      .info-item-left {
        width: 220px;
      }
    }
  }
}
</style>
